import React from 'react'
import GamificationBlock from '../../UI-components/GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../core/widgets'
import './RafflePage.scss'

const RafflePage = () => {
	return (
		<div className="main-content raffle-page">
			<GamificationBlock
				domId={WIDGETS.raffle.domId}
				url={WIDGETS.raffle.url}
				fit="content"
				className="gamification-block--content"
			/>
		</div>
	)
}

export default RafflePage
